// @flow
'use strict';

import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

import CamposBasicos from './campos_basicos';
import CamposCest from './campos_cest';
import CamposOperacao from './campos_operacao';
import CamposIcmsInterestadual from './campos_impostos/campos_icms_interestadual';
import CamposIcms from './campos_impostos/campos_icms';
import CamposPis from './campos_impostos/campos_pis';
import CamposIpi from './campos_impostos/campos_ipi';
import CamposCofins from './campos_impostos/campos_cofins';
import CamposImpostoSeletivo from './campos_impostos/campos_imposto_seletivo';
import CamposIbsCbs from './campos_impostos/campos_ibs_cbs';
import CamposDocumentoReferenciado from './campos_documento_referenciado';
import CamposTotalItem from './campos_total_item';
import CamposImpostoImportacao from './campos_impostos/campos_imposto_importacao';
import CamposPisSt from './campos_impostos/campos_pis_st';
import CamposCofinsSt from './campos_impostos/campos_cofins_st';
import CamposTributosDevolvidos from './campos_impostos/campos_tributos_devolvidos';

type CampoItemNfeProps = {
  component : React.ComponentType<*>,
}

export default function CampoItemNfe({ component } : CampoItemNfeProps) {
  return (
      <Row>
        <Col md={ 6 }>
          <CamposBasicos component={ component }/>
          <CamposOperacao component={ component }/>
          <CamposCest component={ component }/>
          <CamposIcms component={ component }/>
          <CamposIcmsInterestadual/>
          <CamposImpostoImportacao/>
          <CamposIpi/>
          <CamposPis component={ component }/>
          <CamposPisSt/>
          <CamposCofins component={ component }/>
          <CamposCofinsSt/>
          <CamposTributosDevolvidos/>
        </Col>
        <Col md={ 6 }>
          <CamposImpostoSeletivo component={ component }/>
          <CamposIbsCbs component={ component }/>
          <CamposTotalItem component={ component }/>
          <CamposDocumentoReferenciado component={ component }/>
        </Col>
      </Row>
  );
}